module.exports = __webpack_public_path__ + "img/tab-content-image-04.88229d13.png";